import React, { useState, useEffect } from 'react';
import { supabase, nextCustomerCode } from '../supabase';
import { useSettings } from '../useSettings';

const EMPTY = { full_name: '', company: '', type: 'Architect', email: '', phone: '', notes: '', linkedin_url: '' };

export default function CustomerModal({ customer, onClose, onSaved, user, returnRecord=false, contactMode=false }) {
  const { customerTypes } = useSettings();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (customer) setForm(customer);
    else setForm(EMPTY);
  }, [customer]);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.full_name.trim()) { setError('Full name is required.'); return; }
    setSaving(true); setError('');
    const userName = user?.user_metadata?.full_name || user?.email?.split('@')[0] || 'Unknown';
    try {
      let saved=customer;
      if (customer) {
        const { error: e } = await supabase.from('customers').update({
          full_name: form.full_name, company: form.company, type: form.type,
          email: form.email, phone: form.phone, notes: form.notes, linkedin_url: form.linkedin_url||''
        }).eq('id', customer.id);
        if (e) throw e;
      } else {
        const code = await nextCustomerCode();
        const query = supabase.from('customers').insert({
          customer_code: code, full_name: form.full_name, company: form.company,
          type: form.type, email: form.email, phone: form.phone, notes: form.notes, linkedin_url: form.linkedin_url||'',
          created_by: user?.id || null, created_by_name: userName
        });
        const {data,error:e}=await (returnRecord?query.select().single():query);
        saved=data;
        if (e) throw e;
      }
      onSaved(saved);
    } catch (e) { setError(e.message || 'Save failed.'); }
    setSaving(false);
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h2>{contactMode ? (customer ? 'Proje irtibatını düzenle' : 'Yeni proje irtibatı (Contact)') : (customer ? 'Edit Customer' : 'New Customer')}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="form-row cols-2">
            <div><label>Full Name *</label><input value={form.full_name} onChange={e => set('full_name', e.target.value)} placeholder="e.g. James Frost" /></div>
            <div><label>Company</label><input value={form.company} onChange={e => set('company', e.target.value)} placeholder="e.g. ANS Construction Ltd" /></div>
          </div>
          <div className="form-row cols-2">
            <div>
              <label>Type</label>
              <select value={form.type} onChange={e => set('type', e.target.value)}>
                {customerTypes.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div><label>Phone</label><input value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="07xxx xxxxxx" /></div>
          </div>
          <div className="form-row"><div><label>Email</label><input value={form.email} onChange={e => set('email', e.target.value)} placeholder="email@example.com" /></div></div>
          <div className="form-row"><div><label>Company LinkedIn page</label><input type="url" value={form.linkedin_url||''} onChange={e=>set('linkedin_url',e.target.value)} placeholder="https://www.linkedin.com/company/..." /></div></div>
          <div className="form-row"><div><label>Notes</label><textarea rows={3} value={form.notes} onChange={e => set('notes', e.target.value)} placeholder="Any notes about this customer..." /></div></div>
          {error && <p style={{ color: 'var(--red)', fontSize: 13, marginTop: 8 }}>{error}</p>}
        </div>
        <div className="modal-footer">
          <button className="btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn-primary" onClick={save} disabled={saving}>{saving ? 'Saving...' : customer ? 'Save Changes' : (contactMode ? 'İrtibatı oluştur' : 'Create Customer')}</button>
        </div>
      </div>
    </div>
  );
}
